<template>
  <div>
    <h3>{{title}}</h3>
    <table>
      <tr>
        <th>Address No</th>
        <td>{{value.address_n}}</td>
      </tr>
      <tr>
        <th>Address</th>
        <td style="white-space:pre-wrap;">{{value.address}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "Address",
  props: ["value", "title"]
};
</script>